import { useState, useEffect } from "react";
import { Grid, Box, Typography, Button, Divider } from "@mui/material";
import TablePersonalDataAgree from "./TablePendingDocument";
import SearchSelectPerson from "./SearchPerson";
import DateStatusRange from "./DropdownDatePerson";

interface tableData {
    _id: string;
    priority: string;
    document_no: string;
    hname: string;
    files_name: string;
    name: string;
    created_at: string;
    status_user: string;
    status:  string;
}
const MainProvincialPublicHealth: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState("ทั้งหมด");
    const [documentList, setDocumentList] = useState<tableData[]>([]);

    // ฟังก์ชันนับจำนวนเอกสารตามสถานะ
    const countDocuments = (status: string) => {
        if (status === "ทั้งหมด") return documentList.length;

        if (status === "เสร็จสิ้น") {
            return documentList.filter((row) => row.status_user === "approved").length;
        }
        if (status === "รอดำเนินการ") {
            return documentList.filter((row) => row.status_user === "waiting").length;
        }
        if (status === "ยกเลิก") {
            return documentList.filter((row) => row.status_user === "reject").length;
        }
        return 0;
    };


    return (
        <Box sx={{ height: "100%" }}>
            <Grid
                item
                xs={12}
                lg={12}
                sx={{
                    p: 4,
                    background: "#ffffff",
                    borderRadius: "10px",
                    flexWrap: "wrap",
                    width: "100%",
                }}
            >
                {/* Header */}
                <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                        <Typography variant="h5" sx={{ color: "#474747" }}>
                            เอกสารรออนุมัติ
                        </Typography>
                    </Grid>
                </Grid>

                {/* Tabs Section */}
                <Box sx={{ display: "flex", my: 2, flexWrap: "wrap" }}>
                    {["ทั้งหมด", "เสร็จสิ้น", "รอดำเนินการ", "ยกเลิก"].map((tab) => (
                        <Button
                            key={tab}
                            onClick={() => setSelectedTab(tab)}
                            sx={{
                                mr: 1,
                                px: 3,
                                py: 1,
                                borderRadius: "20px",
                                height: "26px",
                                backgroundColor: selectedTab === tab ? "#2F6E89" : "#EDEDED6E",
                                color: selectedTab === tab ? "#fff" : "#2F4491",
                                "&:hover": {
                                    backgroundColor: selectedTab === tab ? "#2F6E89" : "#EDEDED",
                                },
                            }}
                        >
                            {tab} ({countDocuments(tab)})
                        </Button>
                    ))}
                </Box>

                {/* Search & Filters */}
                <Grid item>
                    {/* <SearchSelectPerson /> */}
                </Grid>
                <Grid item sx={{ mt: 2 }}>
                    <Divider sx={{ backgroundColor: "#EEEEEE" }} />
                </Grid>
                <Grid>
                    <DateStatusRange />
                </Grid>

                {/* Table */}
                <Grid item xs={12}>
                    <TablePersonalDataAgree
                        priorityTablePersonalDataAgree="4"
                        selectedTab={selectedTab}
                        setDocumentList={setDocumentList}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default MainProvincialPublicHealth;